import Vue from 'vue';
import Router from 'vue-router';
import {
  ifAuthenticated,
  hasRights,
  allowModuleAccess,
  pageNotFound,
} from '@/helpers/routeHelpers';

// Layouts

// Modules
import UsergroupsOverview from '@/modules/usergroups/overview/UsergroupsOverview.vue';
import UsergroupsDetail from '@/modules/usergroups/detail/UsergroupsDetail.vue';
import UsergroupsAdd from '@/modules/usergroups/add/UsergroupsAdd.vue';
import UsersOverview from '@/modules/users/overview/UsersOverview.vue';
import UsersDetail from '@/modules/users/detail/UsersDetail.vue';
import UsersInvite from '@/modules/users/invite/UsersInvite.vue';
import LogOverview from '@/modules/log/overview/LogOverview.vue';
import LogDetail from '@/modules/log/detail/LogDetail.vue';
import Dashboard from '@/modules/sites/alklima/dashboard/AlklimaDashboard.vue';
import Help from '@/modules/help/Help.vue';
import HelpDetail from '@/modules/help/HelpDetail.vue';
import AuthWrapper from '@/modules/auth/AuthWrapper.vue';
import MeProfile from '@/modules/me/profile/MeProfile.vue';
import LibraryOverview from '@/modules/library/overview/LibraryOverview.vue';
import ImageEditor from '@/modules/library/editor/ImageEditor.vue';
import LibraryDetail from '@/modules/library/detail/LibraryDetail.vue';
import BlogPostOverview from '@/modules/blog/overview/BlogPostOverview.vue';
import EditBlogPost from '@/modules/blog/detail/BlogPost.vue';
import TagsOverview from '@/modules/tags/overview/TagsOverview.vue';
import TagDetail from '@/modules/tags/detail/TagDetail.vue';
import NewsPostOverview from '@/modules/news/post/overview/NewsPostOverview.vue';
import NewsPost from '@/modules/news/post/detail/NewsPost.vue';
import PressOverview from '@/modules/press/post/overview/PressPostOverview.vue';
import PressPost from '@/modules/press/post/detail/PressPost.vue';
import CategoryDetail from '@/modules/categories/detail/CategoryDetail.vue';
import CategoryOverview from '@/modules/categories/overview/CategoryOverview.vue';

import ProductFeatureDetail from '@/modules/sites/alklima/product/features/detail/ProductFeatureDetail.vue';
import ProductCategoryDetail from '@/modules/sites/alklima/product/categories/detail/ProductCategoryDetail.vue';

import BranchDetail from '@/modules/sites/alklima/branch/detail/BranchDetail.vue';
import BranchOverview from '@/modules/sites/alklima/branch/overview/BranchOverview.vue';

import ProductOverview from '@/modules/sites/alklima/product/overview/ProductOverview.vue';
import StructureOverview from '@/modules/sites/alklima/product/structure/overview/StructureOverview.vue';
import StructureNodes from '@/modules/sites/alklima/product/structure/detail/StructureNodes.vue';
import NodeDetail from '@/modules/sites/alklima/product/structure/detail/NodeDetail.vue';

import EtimCombinationOverview from '@/modules/sites/alklima/etimcombinations/overview/EtimCombinationOverview.vue';
import EtimCombinationDetail from '@/modules/sites/alklima/etimcombinations/detail/EtimCombinationDetail.vue';

import FaqCategoryDetail from '@/modules/sites/alklima/faq/categories/detail/FaqCategoryDetail.vue';
import FaqOverview from '@/modules/sites/alklima/faq/overview/FaqOverview.vue';
import FaqQuestionDetail from '@/modules/sites/alklima/faq/questions/detail/FaqQuestionDetail.vue';

import ReferenceDetail from '@/modules/sites/alklima/reference/detail/ReferenceDetail.vue';
import ReferenceOverview from '@/modules/sites/alklima/reference/overview/ReferenceOverview.vue';

import PageDetail from '@/modules/page/detail/PageDetail.vue';
import PageOverview from '@/modules/page/overview/PageOverview.vue';

import PromotionOverview from '@/modules/sites/alklima/promotions/PromotionsOverview.vue';
import PromotionDetail from '@/modules/sites/alklima/promotions/detail/PromotionDetail.vue';

import NetPricePromotionOverview from '@/modules/sites/alklima/netpricepromotions/NetPricePromotionsOverview.vue';
import NetPricePromotionDetail from '@/modules/sites/alklima/netpricepromotions/detail/NetPricePromotionDetail.vue';

import CouponOverview from '@/modules/sites/alklima/coupon/overview/CouponOverview.vue';
import CouponDetail from '@/modules/sites/alklima/coupon/detail/CouponDetail.vue';

import EventOverview from '@/modules/event/overview/EventOverview.vue';
import EventDetail from '@/modules/event/detail/EventDetail.vue';

import PopupOverview from '@/modules/popups/overview/PopupOverview.vue';
import PopupDetail from '@/modules/popups/detail/PopupDetail.vue';

import RedirectDetail from '@/modules/redirect/detail/RedirectDetail.vue';
import RedirectOverview from '@/modules/redirect/overview/RedirectOverview.vue';

import HolidayOverview from '@/modules/sites/alklima/holiday/overview/HolidayOverview.vue';
import HolidayDetail from '@/modules/sites/alklima/holiday/detail/HolidayDetail.vue';

import EmailsOverview from '@/modules/sites/alklima/emails/overview/EmailsOverview.vue';
import EmailDetail from '@/modules/sites/alklima/emails/detail/EmailDetail.vue';

import SparePartsOverview from '@/modules/sites/alklima/spareparts/SparePartsOverview.vue';
import SparePartsDetail from '@/modules/sites/alklima/spareparts/SparePartsDetail.vue';
import SparePartsImage from '@/modules/sites/alklima/spareparts/image/SparePartsImage.vue';
import SparePartCategoryOverview from '@/modules/sites/alklima/spareparts/category/SparePartCategoryOverview.vue';
import SparePartCategoryDetail from '@/modules/sites/alklima/spareparts/category/SparePartCategoryDetail.vue';
import SparePartLogsOverview from '@/modules/sites/alklima/spareparts/logs/SparePartLogsOverview.vue';
import SparePartLogsDetail from '@/modules/sites/alklima/spareparts/logs/SparePartLogsDetail.vue';

import WhitelistDetail from '@/modules/whitelist/detail/WhitelistDetail.vue';
import WhitelistOverview from '@/modules/whitelist/overview/WhitelistOverview.vue';

import FormOverview from '@/modules/sites/alklima/form/FormOverview.vue';
import FormDetail from '@/modules/sites/alklima/form/detail/FormDetail.vue';
import MenuItemDetail from '@/modules/menu/item/MenuItemDetail.vue';
import MenuOverview from '@/modules/menu/overview/MenuOverview.vue';
import MenuDetail from '@/modules/menu/detail/MenuDetail.vue';

import ErrorcodeDetail from '@/modules/sites/alklima/errorcode/detail/ErrorcodeDetail.vue';
import ErrorcodeOverview from '@/modules/sites/alklima/errorcode/overview/ErrorcodeOverview.vue';

import QueueOverview from '@/modules/sites/alklima/queue/overview/QueueOverview.vue';

import StatisticsOverview from '@/modules/sites/alklima/statistics/overview/StatisticsOverview.vue';

import DefaultCartsOverview from '@/modules/sites/alklima/defaultcarts/overview/DefaultCartsOverview.vue';
import DefaultCartsUsageOverview from '@/modules/sites/alklima/defaultcarts/overview/DefaultCartsUsageOverview.vue';
import DefaultCartsDetail from '@/modules/sites/alklima/defaultcarts/detail/DefaultCartsDetail.vue';

import DnsOverview from '@/modules/sites/alklima/dns/overview/DnsOverview.vue';

import SearchLogOverview from '@/modules/sites/alklima/searchlog/SearchLogOverview.vue';

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import OutsideLayout from '@/layouts/OutsideLayout.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  // base: '/ctrlroom.alklima.nl/',
  routes: [
    //  '/'
    {
      path: '/',
      component: DefaultLayout,
      beforeEnter: ifAuthenticated,
      children: [
        //  ''
        {
          path: '',
          redirect: {
            name: 'Dashboard',
          },
        },
        //  '/dashboard'
        {
          path: '/dashboard',
          name: 'Dashboard',
          meta: {
            title: 'dashboard',
            help: 'module.name.dashboard',
          },
          component: Dashboard,
        },
        //  'errorcode'
        {
          path: 'errorcode',
          name: 'ErrorcodeOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'errorcode',
            help: 'module.name.errorcode',
            permission: 'errorcode',
          },
          component: ErrorcodeOverview,
        },
        //  'errorcode/add'
        {
          path: 'errorcode/add',
          name: 'ErrorcodeAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'errorcode',
            action: 'add',
            permission: 'errorcode.add',
            help: 'module.name.errorcode',
          },
          component: ErrorcodeDetail,
        },
        //  'errorcode/:id'
        {
          path: 'errorcode/:id',
          name: 'ErrorcodeEdit',
          beforeEnter: hasRights,
          meta: {
            title: 'errorcode',
            action: 'edit',
            permission: 'errorcode.edit',
            help: 'module.name.errorcode',
          },
          component: ErrorcodeDetail,
        },

        {
          path: 'queue',
          name: 'Jobs',
          meta: {
            title: 'Jobs',
            help: 'module.name.queue',
            action: 'edit',
          },
          component: QueueOverview,
        },
        //  'structure'
        {
          path: 'structure',
          name: 'StrucureOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'structure',
            help: 'module.name.structure',
            permission: 'structure',
          },
          component: StructureOverview,
        },
        //  'structure/:structure'
        {
          path: 'structure/:structure',
          name: 'StructureNodes',
          beforeEnter: hasRights,
          meta: {
            title: 'structure',
            help: 'module.name.structure',
            permission: 'structure.edit',
          },
          component: StructureNodes,
        },
        //  'structure/:structure/node/:id'
        {
          path: 'structure/:structure/node/:id',
          name: 'NodeDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'structure',
            action: 'edit',
            help: 'module.name.structure',
            permission: 'structure.edit',
          },
          component: NodeDetail,
        },
        //  'etim/combination'
        {
          path: 'etim/combination',
          name: 'EtimCombinationOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'etimcombination',
            help: 'module.name.etim',
            permission: 'etim',
          },
          component: EtimCombinationOverview,
        },
        //  'etim/combination/add'
        {
          path: 'etim/combination/add',
          name: 'EtimCombinationDetail',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'etimcombination',
            help: 'module.name.etim',
            action: 'add',
            permission: 'etim',
          },
          component: EtimCombinationDetail,
        },
        //  'etim/combination/:id'
        {
          path: 'etim/combination/:id',
          name: 'EtimCombinationDetail',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'etimcombination',
            help: 'module.name.etim',
            action: 'edit',
            permission: 'etim',
          },
          component: EtimCombinationDetail,
        },
        //  'etim/category'
        {
          path: 'etim/category',
          alias: '/etim',
          name: 'ProductOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'etim',
            help: 'module.name.etim',
            permission: 'etim',
          },
          component: ProductOverview,
        },
        //  'etim/feature/:id'
        {
          path: 'etim/feature/:id',
          name: 'ProductFeatureDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'etim',
            action: 'edit',
            help: 'module.name.etim',
            permission: 'etim.feature.edit',
          },
          component: ProductFeatureDetail,
        },
        //  'etim/category/add'
        {
          path: 'etim/category/add',
          name: 'ProductCategoryAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'category',
            action: 'add',
            help: 'module.name.etim',
            permission: 'etim.category.add',
          },
          component: ProductCategoryDetail,
        },
        //  'etim/category/:id'
        {
          path: 'etim/category/:id',
          name: 'ProductCategoryDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'etim',
            action: 'edit',
            help: 'module.name.etim',
            permission: 'etim.category.edit',
          },
          component: ProductCategoryDetail,
        },
        //  'faq'
        {
          path: 'faq',
          name: 'FaqOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'faq',
            help: 'module.name.faq',
            permission: 'faq',
          },
          component: FaqOverview,
        },
        //  'faq/category/add'
        {
          path: 'faq/category/add',
          name: 'FaqCategoryAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'faq',
            action: 'add',
            help: 'module.name.faq',
            permission: 'faq.category.add',
          },
          component: FaqCategoryDetail,
        },
        //  'faq/category/:id'
        {
          path: 'faq/category/:id',
          name: 'FaqCategoryDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'faq',
            action: 'edit',
            help: 'module.name.faq',
            permission: 'faq.category.edit',
          },
          component: FaqCategoryDetail,
        },
        //  'faq/question/add'
        {
          path: 'faq/question/add',
          name: 'FaqQuestionAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'faq',
            action: 'add',
            help: 'module.name.faq',
            permission: 'faq.question.add',
          },
          component: FaqQuestionDetail,
        },
        //  'faq/category/:category/question/:id'
        {
          path: 'faq/category/:category/question/:id',
          name: 'FaqQuestionDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'faq',
            action: 'edit',
            help: 'module.name.faq',
            permission: 'faq.question.edit',
          },
          component: FaqQuestionDetail,
        },
        //  '/news'
        {
          path: '/news',
          name: 'NewsPostOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'news',
            help: 'module.name.news',
            permission: 'news',
          },
          component: NewsPostOverview,
        },
        //  '/news/add'
        {
          path: '/news/add',
          name: 'AddNewsPost',
          beforeEnter: hasRights,
          meta: {
            action: 'add',
            title: 'news',
            help: 'module.name.news',
            permission: 'news.add',
          },
          component: NewsPost,
        },
        //  '/news/:id'
        {
          path: '/news/:id',
          name: 'EditNews',
          beforeEnter: hasRights,
          meta: {
            action: 'edit',
            title: 'news',
            help: 'module.name.news',
            permission: 'news.edit',
          },
          component: NewsPost,
        },
        //  '/blog'
        {
          path: '/blog',
          name: 'BlogPostOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'blog',
            help: 'module.name.blog:',
            permission: 'blog',
          },
          component: BlogPostOverview,
        },
        //  '/blog/add'
        {
          path: '/blog/add',
          name: 'AddBlogPost',
          beforeEnter: hasRights,
          meta: {
            title: 'blog',
            help: 'module.name.blog',
            action: 'add',
            permission: 'blog.add',
          },
          component: EditBlogPost,
        },
        //  '/blog/:id'
        {
          path: '/blog/:id',
          name: 'EditBlog',
          beforeEnter: hasRights,
          meta: {
            title: 'blog',
            help: 'module.name.blog',
            action: 'edit',
            permission: 'blog.edit',
          },
          component: EditBlogPost,
        },
        //  '/branch'
        {
          path: '/branch',
          name: 'BranchOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'branch',
            help: 'module.name.branch',
            permission: 'branch',
          },
          component: BranchOverview,
        },
        //  '/branch/add'
        {
          path: '/branch/add',
          name: 'AddBranch',
          beforeEnter: hasRights,
          meta: {
            title: 'branch',
            help: 'module.name.branch',
            action: 'add',
            permission: 'branch.add',
          },
          component: BranchDetail,
        },
        //  '/branch/:id'
        {
          path: '/branch/:id',
          name: 'EditBranch',
          beforeEnter: hasRights,
          meta: {
            title: 'branch',
            help: 'module.name.branch',
            action: 'edit',
            permission: 'branch.edit',
          },
          component: BranchDetail,
        },
        //  '/page'
        {
          path: '/page',
          name: 'PageOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'page',
            help: 'module.name.page',
            permission: 'page',
          },
          component: PageOverview,
        },
        //  '/page/add'
        {
          path: '/page/add',
          name: 'AddPage',
          beforeEnter: hasRights,
          meta: {
            title: 'page',
            help: 'module.name.page',
            action: 'add',
            permission: 'page.add',
          },
          component: PageDetail,
        },
        //  '/page/:id'
        {
          path: '/page/:id',
          name: 'EditPage',
          beforeEnter: hasRights,
          meta: {
            title: 'page',
            help: 'module.name.page',
            action: 'edit',
            permission: 'page.edit',
          },
          component: PageDetail,
        },
        //  '/reference'
        {
          path: '/reference',
          name: 'ReferenceOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'reference',
            help: 'module.name.reference',
            permission: 'reference',
          },
          component: ReferenceOverview,
        },
        //  '/reference/add'
        {
          path: '/reference/add',
          name: 'AddReference',
          beforeEnter: hasRights,
          meta: {
            title: 'reference',
            help: 'module.name.reference',
            action: 'add',
            permission: 'reference.add',
          },
          component: ReferenceDetail,
        },
        //  '/reference/:id'
        {
          path: '/reference/:id',
          name: 'ReferenceDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'reference',
            help: 'module.name.reference',
            action: 'edit',
            permission: 'reference.edit',
          },
          component: ReferenceDetail,
        },
        //  '/tag'
        {
          path: '/tag',
          name: 'TagsOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'tags',
            help: 'module.name.tags',
            permission: 'tag',
          },
          component: TagsOverview,
        },
        //  '/tag/add'
        {
          path: '/tag/add',
          name: 'TagAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'tags',
            help: 'module.name.tags',
            action: 'add',
            permission: 'tag.add',
          },
          component: TagDetail,
        },
        //  '/tag/:id'
        {
          path: '/tag/:id',
          name: 'TagDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'tags',
            help: 'module.name.tags',
            action: 'edit',
            permission: 'tag.edit',
          },
          component: TagDetail,
        },
        //  '/category'
        {
          path: '/category',
          name: 'CategoryOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'categories',
            help: 'module.name.categories',
            permission: 'category',
          },
          component: CategoryOverview,
        },
        //  '/category/add'
        {
          path: '/category/add',
          name: 'CategoryAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'category',
            help: 'module.name.category',
            action: 'add',
            permission: 'category.add',
          },
          component: CategoryDetail,
        },
        //  '/category/:id'
        {
          path: '/category/:id',
          name: 'CategoryDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'categories',
            help: 'module.name.categories',
            action: 'edit',
            permission: 'category.edit',
          },
          component: CategoryDetail,
        },
        //  '/press'
        {
          path: '/press',
          name: 'PressOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'press',
            help: 'module.name.press',
            permission: 'press',
          },
          component: PressOverview,
        },
        //  '/press/add'
        {
          path: '/press/add',
          name: 'AddPressPost',
          beforeEnter: hasRights,
          meta: {
            action: 'add',
            title: 'press',
            help: 'module.name.press',
            permission: 'press.add',
          },
          component: PressPost,
        },
        //  '/press/:id'
        {
          path: '/press/:id',
          name: 'EditPress',
          beforeEnter: hasRights,
          meta: {
            action: 'edit',
            title: 'press',
            help: 'module.name.press',
            permission: 'press.edit',
          },
          component: PressPost,
        },
        //  '/help'
        {
          path: '/help',
          name: 'Help',
          meta: {
            title: 'help',
          },
          component: Help,
        },
        //  '/help/:type'
        {
          path: '/help/:type',
          name: 'HelpDetailGeneral',
          meta: {
            title: 'help',
          },
          component: HelpDetail,
        },
        //  '/help/:type/:module'
        {
          path: '/help/:type/:module',
          name: 'HelpDetailModule',
          meta: {
            title: 'help',
          },
          component: HelpDetail,
        },
        //  '/usergroups'
        {
          path: '/usergroups',
          name: 'UsergroupsOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'usergroups',
            permission: 'usergroups',
            help: 'module.name.usergroups',
          },
          component: UsergroupsOverview,
        },
        //  '/usergroups/add'
        {
          path: '/usergroups/add',
          name: 'UsergroupsAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'usergroups',
            action: 'add',
            permission: 'usergroups.add',
            help: 'module.name.usergroups',
          },
          component: UsergroupsAdd,
        },
        //  '/usergroups/:id'
        {
          path: '/usergroups/:id',
          name: 'UsergroupsDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'usergroups',
            action: 'edit',
            permission: 'usergroups.edit',
            help: 'module.name.usergroups',
          },
          component: UsergroupsDetail,
        },
        //  '/users'
        {
          path: '/users',
          name: 'UsersOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'users',
            permission: 'users',
            help: 'module.name.users',
          },
          component: UsersOverview,
        },
        //  '/users/invite'
        {
          path: '/users/invite',
          name: 'UsersInvite',
          beforeEnter: hasRights,
          meta: {
            title: 'users',
            action: 'invite',
            permission: 'users.add',
            help: 'module.name.users',
          },
          component: UsersInvite,
        },
        //  '/users/:id'
        {
          path: '/users/:id',
          name: 'UsersDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'users',
            permission: 'users.edit',
            action: 'edit',
            help: 'module.name.users',
          },
          component: UsersDetail,
        },
        //  '/logs'
        {
          path: '/logs',
          name: 'LogOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'logs',
          },
          component: LogOverview,
        },
        //  '/logs/:id'
        {
          path: '/logs/:id',
          name: 'LogDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'logs',
            action: 'details',
            help: 'module.name.logs',
          },
          component: LogDetail,
        },
        //  '/profile'
        {
          path: '/profile',
          name: 'MeProfile',
          meta: {
            title: 'profile',
            help: 'module.name.profile',
          },
          component: MeProfile,
        },
        //  '/library'
        {
          path: '/library',
          name: 'Library',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'library',
            permission: 'library',
            help: 'module.name.library',
          },
          component: LibraryOverview,
        },
        //  '/library/:filename'
        {
          path: '/library/:filename',
          name: 'LibraryDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'library',
            action: 'details',
            permission: 'library.edit',
            help: 'module.name.library',
          },
          component: LibraryDetail,
        },
        //  '/library/:filename/edit'
        {
          path: '/library/:filename/edit',
          name: 'LibraryEdit',
          meta: {
            title: 'library',
            action: 'edit',
            permission: 'library.edit',
            help: 'module.name.library',
          },
          component: ImageEditor,
        },
        //  '/navigation'
        {
          path: '/navigation',
          name: 'MenuOverview',
          meta: {
            title: 'navigation',
            help: 'module.name.menu',
          },
          component: MenuOverview,
        },
        //  '/navigation/add'
        {
          path: '/navigation/add',
          name: 'MenuAdd',
          meta: {
            title: 'navigation',
            permission: 'navigation.menu.add',
            action: 'add',
            help: 'module.name.menu',
          },
          component: MenuDetail,
        },
        //  '/navigation/:id/menu'
        // {
        //   path: '/navigation/:id/menu',
        //   name: 'MenuDetail',
        //   meta: {
        //     title: 'navigation',
        //     permission: 'navigation.menu',
        //     action: 'edit',
        //     help: 'module.name.menu',
        //   },
        //   component: MenuDetail,
        // },
        //  '/navigation/:id'
        {
          path: '/navigation/:id',
          name: 'MenuItemDetail',
          meta: {
            title: 'navigation',
            permission: 'navigation.menu.edit',
            action: 'edit',
            help: 'module.name.menu',
          },
          component: MenuItemDetail,
        },
        //  '/promotion'
        {
          path: '/promotion',
          name: 'PromotionOverview',
          meta: {
            title: 'promotion',
            permission: 'promotion',
            help: 'module.name.promotion',
          },
          component: PromotionOverview,
        },
        //  '/promotion/add'
        {
          path: '/promotion/add',
          name: 'PromotionAdd',
          meta: {
            title: 'promotion',
            permission: 'promotion',
            action: 'add',
            help: 'module.name.promotion',
          },
          component: PromotionDetail,
        },
        //  '/promotion/:id'
        {
          path: '/promotion/:id',
          name: 'PromotionDetail',
          meta: {
            title: 'promotion',
            permission: 'promotion',
            action: 'add',
            help: 'module.name.promotion',
          },
          component: PromotionDetail,
        },
        //  '/netPricepromotion'
        {
          path: '/netPricepromotion',
          name: 'NetPricePromotionOverview',
          meta: {
            title: 'netPricepromotion',
            permission: 'promotion',
            help: 'module.name.netPricepromotion',
          },
          component: NetPricePromotionOverview,
        },
        //  '/netPricepromotion/add'
        {
          path: '/netPricepromotion/add',
          name: 'NetPricePromotionAdd',
          meta: {
            title: 'netPricepromotion',
            permission: 'netPricepromotion',
            action: 'add',
            help: 'module.name.netPricepromotion',
          },
          component: NetPricePromotionDetail,
        },
        //  '/netPricepromotion/:id'
        {
          path: '/netPricepromotion/:id',
          name: 'NetPricePromotionDetail',
          meta: {
            title: 'netPricepromotion',
            permission: 'netPricepromotion',
            action: 'add',
            help: 'module.name.netPricepromotion',
          },
          component: NetPricePromotionDetail,
        },
        //  '/coupon'
        {
          path: '/coupon',
          name: 'CouponOverview',
          meta: {
            title: 'coupon',
            permission: 'coupon',
            help: 'module.name.coupon',
          },
          component: CouponOverview,
        },
        //  '/coupon/add'
        {
          path: '/coupon/add',
          name: 'CouponAdd',
          meta: {
            title: 'coupon',
            permission: 'coupon',
            action: 'add',
            help: 'module.name.coupon',
          },
          component: CouponDetail,
        },
        //  '/coupon/:id'
        {
          path: '/coupon/:id',
          name: 'CouponDetail',
          meta: {
            title: 'coupon',
            permission: 'coupon',
            action: 'add',
            help: 'module.name.coupon',
          },
          component: CouponDetail,
        },
        //  '/event'
        {
          path: '/event',
          name: 'EventOverview',
          meta: {
            title: 'event',
            permission: 'event',
            help: 'module.name.event',
          },
          component: EventOverview,
        },
        //  '/event/add'
        {
          path: '/event/add',
          name: 'EventAdd',
          meta: {
            title: 'event',
            permission: 'event',
            help: 'module.name.event',
            action: 'add',
          },
          component: EventDetail,
        },
        //  '/event/:id'
        {
          path: '/event/:id',
          name: 'EventDetail',
          meta: {
            title: 'event',
            permission: 'event',
            help: 'module.name.event',
            action: 'edit',
          },
          component: EventDetail,
        },
        //  '/popup'
        {
          path: '/popup',
          name: 'PopupOverview',
          meta: {
            title: 'popup',
            help: 'module.name.popup',
          },
          component: PopupOverview,
        },
        //  '/popup/add'
        {
          path: '/popup/add',
          name: 'PopupAdd',
          meta: {
            title: 'popup',
            help: 'module.name.popup',
            action: 'add',
          },
          component: PopupDetail,
        },
        //  '/popup/:id'
        {
          path: '/popup/:id',
          name: 'PopupDetail',
          meta: {
            title: 'popup',
            help: 'module.name.popup',
            action: 'edit',
          },
          component: PopupDetail,
        },
        {
          path: '/redirect',
          name: 'RedirectOverview',
          meta: {
            title: 'redirect',
            help: 'module.name.redirect',
          },
          component: RedirectOverview,
        },
        {
          path: '/redirect/add',
          name: 'RedirectAdd',
          meta: {
            title: 'redirect',
            help: 'module.name.redirect',
            action: 'add',
          },
          component: RedirectDetail,
        },
        {
          path: '/redirect/:id',
          name: 'RedirectDetail',
          meta: {
            title: 'redirect',
            help: 'module.name.redirect',
            action: 'edit',
          },
          component: RedirectDetail,
        },
        {
          path: '/whitelist',
          name: 'WhitelistOverview',
          meta: {
            title: 'whitelist',
            help: 'module.name.whitelist',
          },
          component: WhitelistOverview,
        },
        {
          path: '/whitelist/add',
          name: 'WhitelistAdd',
          meta: {
            title: 'whitelist',
            help: 'module.name.whitelist',
            action: 'add',
          },
          component: WhitelistDetail,
        },
        {
          path: '/whitelist/:id',
          name: 'WhitelistDetail',
          meta: {
            title: 'whitelist',
            help: 'module.name.whitelist',
            action: 'edit',
          },
          component: WhitelistDetail,
        },
        {
          path: '/holidays',
          name: 'HolidayOverview',
          meta: {
            title: 'holidays',
            help: 'module.name.holidays',
          },
          component: HolidayOverview,
        },
        {
          path: '/holidays/add',
          name: 'HolidayAdd',
          meta: {
            title: 'holidays',
            help: 'module.name.holidays',
            action: 'add',
          },
          component: HolidayDetail,
        },
        {
          path: '/holidays/:id',
          name: 'HolidayDetail',
          meta: {
            title: 'holidays',
            help: 'module.name.holidays',
            action: 'edit',
          },
          component: HolidayDetail,
        },
        {
          path: '/emails',
          name: 'EmailsOverview',
          meta: {
            title: 'emails',
          },
          component: EmailsOverview,
        },
        {
          path: '/emails/:id',
          name: 'EmailDetail',
          meta: {
            title: 'emails',
            action: 'edit',
          },
          component: EmailDetail,
        },
        {
          path: '/spare-parts',
          name: 'SparePartsOverview',
          meta: {
            title: 'spare-parts',
          },
          component: SparePartsOverview,
        },
        {
          path: '/spare-parts/:id/image/:categoryId',
          name: 'SparePartsImage',
          meta: {
            title: 'spare-parts',
            action: 'edit',
          },
          component: SparePartsImage,
        },
        {
          path: '/spare-parts/:id',
          name: 'SparePartsDetail',
          meta: {
            title: 'spare-parts',
            action: 'edit',
          },
          component: SparePartsDetail,
        },
        {
          path: '/spare-part-categories',
          name: 'SparePartCategoryOverview',
          meta: {
            title: 'spare-part-categories',
          },
          component: SparePartCategoryOverview,
        },
        {
          path: '/spare-part-categories/:id',
          name: 'SparePartCategoryDetail',
          meta: {
            title: 'spare-part-categories',
            action: 'edit',
          },
          component: SparePartCategoryDetail,
        },
        {
          path: '/spare-part-logs',
          name: 'SparePartLogsOverview',
          meta: {
            title: 'spare-part-logs',
          },
          component: SparePartLogsOverview,
        },
        {
          path: '/spare-part-logs/:id',
          name: 'SparePartLogsDetail',
          meta: {
            title: 'spare-part-logs',
            action: 'details',
          },
          component: SparePartLogsDetail,
        },
        {
          path: '/statistics/:activeTab?',
          name: 'StatisticsOverview',
          meta: {
            title: 'statistics',
            action: 'view',
          },
          component: StatisticsOverview,
        },
        //  '/form'
        {
          path: '/form',
          name: 'FormOverview',
          meta: {
            title: 'form',
            permission: 'form',
            help: 'module.name.form',
          },
          component: FormOverview,
        },
        //  '/form/add'
        {
          path: '/form/add',
          name: 'FormAdd',
          meta: {
            title: 'form',
            permission: 'form',
            action: 'add',
            help: 'module.name.form',
          },
          component: FormDetail,
        },
        //  '/form/:id'
        {
          path: '/form/:id',
          name: 'FormDetail',
          meta: {
            title: 'form',
            permission: 'form',
            action: 'add',
            help: 'module.name.form',
          },
          component: FormDetail,
        },
        //  '/defaultcart'
        {
          path: '/defaultcart',
          name: 'defaultcart',
          meta: {
            title: 'defaultcart',
            permission: 'defaultcart',
            help: 'module.name.form',
          },
          component: DefaultCartsOverview,
        },
        {
          path: '/defaultcart/:id/usage',
          name: 'defaultcartUsage',
          meta: {
            title: 'defaultcart',
            permission: 'defaultcart',
            help: 'module.name.form',
          },
          component: DefaultCartsUsageOverview,
        },
        //  '/defaultcart/add'
        {
          path: '/defaultcart/add',
          name: 'defaultCartAdd',
          meta: {
            title: 'defaultcart',
            permission: 'defaultcart',
            help: 'module.name.form',
          },
          component: DefaultCartsDetail,
        },
        //  '/defaultcart/:id'
        {
          path: '/defaultcart/:id',
          name: 'defaultCartDetail',
          meta: {
            title: 'defaultcart',
            permission: 'defaultcart',
            help: 'module.name.form',
          },
          component: DefaultCartsDetail,
        },
        // DnsOverview
        {
          path: '/dns',
          name: 'DnsOverview',
          meta: {
            title: 'dns',
            permission: 'dns',
            help: 'module.name.dns',
          },
          component: DnsOverview,
        },
        // Search history Overview
        {
          path: '/searchlog',
          name: 'SeachLogOverview',
          meta: {
            title: 'searchlog',
            permission: 'searchlog',
          },
          component: SearchLogOverview,
        },
      ],
    },
    //  '/auth'
    {
      path: '/auth',
      alias: '/',
      component: OutsideLayout,
      children: [
        //  'login'
        {
          path: 'login',
          name: 'login',
          component: AuthWrapper,
        },
        //  'reset'
        {
          path: 'reset',
          name: 'reset',
          component: AuthWrapper,
        },
        //  'reset/:email/:code'
        {
          path: 'reset/:email/:code',
          name: 'inputResetPassword',
          component: AuthWrapper,
        },
        //  'accept/:email/:code'
        {
          path: 'accept/:email/:code',
          name: 'accept',
          component: AuthWrapper,
        },
      ],
    },
    //  '*'
    {
      path: '*',
      beforeEnter: pageNotFound,
    },
  ],
});
